// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"64":"b9223cc5","150":"498252ce","740":"cf895705"}[chunkId] + ".chunk.js");